import debounce from 'lodash.debounce';
import { useCallback, useRef, useState } from 'react';

export const useOnSearch = () => {
  const [searchStr, setSearchStr] = useState<string>('');

  const onSearch = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchStr(e.target.value);
  }, []);

  const onSearchDebounced = useRef(debounce(onSearch, 1000)).current;

  return { searchStr, onSearch, onSearchDebounced };
};
